export interface LigneSaisieManuelle {
  compte: string;
  libelle: string;
  debit: number;
  credit: number;
  /** Axe analytique / centre de coût (A-05). */
  axe_cdc?: string;
}

export function totauxSaisieManuelle(lignes: readonly LigneSaisieManuelle[]): {
  debit: number;
  credit: number;
} {
  return {
    debit: lignes.reduce((s, l) => s + (Number.isFinite(l.debit) ? l.debit : 0), 0),
    credit: lignes.reduce((s, l) => s + (Number.isFinite(l.credit) ? l.credit : 0), 0),
  };
}

/** `null` si la saisie peut être enregistrée, sinon le motif de rejet. */
export function validerSaisieManuelle(
  lignes: readonly LigneSaisieManuelle[],
  date: string,
  libelle: string,
): string | null {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(date)) return 'Date requise (YYYY-MM-DD)';
  if (!libelle.trim()) return 'Libellé requis';
  const utiles = lignes.filter((l) => l.compte.trim() && (l.debit > 0 || l.credit > 0));
  if (utiles.length < 2) return 'Au moins deux lignes mouvementées sont requises';
  for (const l of utiles) {
    if (!/^\d{2,8}$/.test(l.compte.trim())) return `Compte OHADA invalide : ${l.compte}`;
    if (l.debit > 0 && l.credit > 0)
      return 'Une ligne ne peut pas porter à la fois un débit et un crédit';
  }
  const totaux = totauxSaisieManuelle(utiles);
  if (totaux.debit !== totaux.credit) return 'Écriture non équilibrée';
  if (totaux.debit <= 0) return 'Montant nul';
  return null;
}

export function lignesUtiles(lignes: readonly LigneSaisieManuelle[]): LigneSaisieManuelle[] {
  return lignes.filter((l) => l.compte.trim() && (l.debit > 0 || l.credit > 0));
}
